import { jsx as _jsx } from "react/jsx-runtime";
export const CdpPreviewTemplateCSS = () => (_jsx("style", { children: `
        header, footer {
            display: none;
        }
    ` }));
